module.exports = __webpack_public_path__ + "img/17.442bc2f5.jpg";